import { PARTICIPANT_JOINED, PARTICIPANT_LEFT } from 'jitsi/base/participants/actionTypes';
import MiddlewareRegistry from 'jitsi/base/redux/MiddlewareRegistry';
import { getCameraInactiveParticipants, getParticipantsByCameraState, setCameraInactiveParticipants, setParticipantsByCameraState, } from './functions';
import { without } from 'lodash';
MiddlewareRegistry.register((store) => (next) => (action) => {
    const { dispatch, getState } = store;
    switch (action.type) {
        case PARTICIPANT_JOINED: {
            const { participant } = action;
            if (participant.fakeParticipant || participant.local)
                break;
            const state = getState();
            const participantsList = getCameraInactiveParticipants(state);
            dispatch(setCameraInactiveParticipants([...participantsList, participant.id]));
            break;
        }
        case PARTICIPANT_LEFT: {
            const { id, fakeParticipant } = action.participant;
            if (fakeParticipant)
                break;
            const state = getState();
            const { active, inactive } = getParticipantsByCameraState(state);
            // Check when the ID changes when the participant updates in the reducer.
            dispatch(setParticipantsByCameraState({
                active: active.includes(id) ? without(active, id) : active,
                inactive: inactive.includes(id) ? without(inactive, id) : inactive,
            }));
            break;
        }
    }
    return next(action);
});
